import { RiWhatsappFill } from "react-icons/ri";
import MCubeLogo from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/MCubeLogo";

export default function WhatsappMCubeEngageIcon() {
  return (
    <div className="flex items-center relative">
      <RiWhatsappFill className="size-5 text-green-500 m-2" />
      <div className="absolute -bottom-0 -right-0">
        <MCubeLogo width={16} height={16}/>
      </div>
    </div>
  );
}
